import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {visibilityEventColumns} from './columns/_columns'
import {VisibilityEventModel} from '../core/_models'
import {ParametersListLoading} from '../components/loading/ParametersListLoading'
import {ParametersListPagination} from '../components/pagination/ParametersListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'
import { FormattedMessage } from 'react-intl'

const VisibilityEventTable = () => {
  const visibilityEvent = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => visibilityEvent,[visibilityEvent])
  const columns = useMemo(() => visibilityEventColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<VisibilityEventModel>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-500' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<VisibilityEventModel>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  {<FormattedMessage id ="NO.RECORD.FOUND"/>}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ParametersListPagination />
      {isLoading && <ParametersListLoading />}
    </KTCardBody>
  )
}

export {VisibilityEventTable}
